import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import fetchReducer from './fetch.reducer.js'

export default combineReducers({
  router: routerReducer,
  apiData: fetchReducer
})



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/_rootReducer.js
// module id = 172
// module chunks = 0